import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  MessageSquare, BarChart3, ListTodo, Lightbulb, History,
  Database, FolderOpen, Settings
} from 'lucide-react';

const TABS = [
  { id: 'chat', label: 'Chat', icon: MessageSquare, path: '/admin/trados-agent' },
  { id: 'overview', label: 'Overview', icon: BarChart3, path: '/admin/trados-agent/overview' },
  { id: 'tasks', label: 'Tasks', icon: ListTodo, path: '/admin/trados-agent/tasks' },
  { id: 'suggestions', label: 'Suggestions', icon: Lightbulb, path: '/admin/trados-agent/suggestions' },
  { id: 'history', label: 'History', icon: History, path: '/admin/trados-agent/history' },
  { id: 'memory', label: 'Memory', icon: Database, path: '/admin/trados-agent/memory' },
  { id: 'files', label: 'Files', icon: FolderOpen, path: '/admin/trados-agent/files' },
  { id: 'settings', label: 'Settings', icon: Settings, path: '/admin/trados-agent/settings' },
];

const AgentTabNav = ({ stats }) => {
  const location = useLocation();

  const isActive = (tab) => {
    if (tab.id === 'chat') {
      return location.pathname === '/admin/trados-agent' || location.pathname === '/admin/trados-agent/chat';
    }
    return location.pathname === tab.path || location.pathname.startsWith(tab.path + '/');
  };

  return (
    <div className="flex gap-1 mb-6 bg-white rounded-xl border border-gray-200 p-1">
      {TABS.map(tab => {
        const Icon = tab.icon;
        const active = isActive(tab);
        return (
          <Link
            key={tab.id}
            to={tab.path}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all flex-1 justify-center ${
              active ? 'bg-indigo-600 text-white shadow-sm' : 'text-gray-600 hover:bg-gray-50'
            }`}
          >
            <Icon className="w-4 h-4" />
            {tab.label}
            {tab.id === 'suggestions' && stats?.suggestions?.pending_review > 0 && (
              <span className={`w-5 h-5 rounded-full text-xs flex items-center justify-center ${
                active ? 'bg-white/20 text-white' : 'bg-amber-100 text-amber-700'
              }`}>{stats.suggestions.pending_review}</span>
            )}
          </Link>
        );
      })}
    </div>
  );
};

export default AgentTabNav;
